import { request } from '../client';

export const listFavourites = () => request('/favourites');

export const addFavourite = (productId) => request(`/favourites/${productId}`, { method: 'POST' });

export const removeFavourite = (productId) => request(`/favourites/${productId}`, { method: 'DELETE' });
